import axios from 'axios';
import { clearStoredAuth, getStoredToken } from '../context/AuthContext';

export const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
});

httpClient.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearStoredAuth();
      window.location.assign('/login');
    }
    return Promise.reject(error);
  }
);

export const unwrap = (response) => response.data?.data;
